<template>
  <div class="flex-item">
    <div
      :class="['tile', recipe.flavor, getActiveRecipe === index ? 'open' : '']"
      v-on:click="() => setActiveRecipe(index)"
    >
      <h3 v-html="recipe.title"></h3>
      <div v-if="recipe.featured" class="new"></div>
      <div v-if="recipe.isHoliday" class="holiday"></div>
      <img
        class="desktop"
        :src="getImgUrl(recipe.flavor).desktop"
        v-bind:alt="[recipe.flavor + ' can']"
      />
      <img
        class="mobile"
        :src="getImgUrl(recipe.flavor).mobile"
        v-bind:alt="[recipe.flavor + ' can']"
      />
      <custom-icon class="btn-arrow" :link="arrow"></custom-icon>
    </div>
    <showcase-window
      :class="['mobile', getActiveRecipe === index ? 'open' : '']"
      :recipe="recipe"
      :cta="mixologyData.CTA"
    ></showcase-window>
  </div>
</template>

<script>
import CustomIcon from "@/components/custom-icons/Icon";
import arrow from "@/assets/mixology/icons/arrow.svg";
import mixologyData from "./../../../static/libs/mixology";
import ShowcaseWindow from "@/components/mixology/ShowcaseWindow";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "tile",
  props: {
    recipe: {
      type: Object
    },
    index: {
      type: Number
    },
    data: {
      type: Object
    }
  },
  computed: mapGetters(["getActiveRecipe"]),
  methods: {
    ...mapActions(["setActiveRecipe"]),
    getImgUrl: flavor => {
      const images = require.context(
        "./../../assets/mixology/cans/",
        false,
        /\.png$/
      );
      return {
        desktop: images("./" + flavor + "_th.png"),
        mobile: images("./" + flavor + "_m_th.png")
      };
    },
    setTitleColors: title => {
      console.log(title);
      const words = title.split(" ");
      const delimiter = /\n/g;
      return words
        .map((word, i) => {
          return word.match(delimiter)
            ? `<span>${word.replaceAll(delimiter, "")}</span>`
            : word;
        })
        .join("");
    }
  },
  data() {
    return {
      arrow,
      mixologyData
    };
  },
  components: {
    CustomIcon,
    ShowcaseWindow
  }
};
</script>

<style lang="scss">
@import "./../../css-abstracts/_tiles.scss";

.flex-item {
  @media (min-width: 768px) {
    flex: 0 1 50%;
  }
  @media (min-width: 1200px) {
    flex: 0 1 33.33%;
  }
  @media (min-width: 1600px) {
    flex: 0 1 25%;
  }
}

.tile {
  position: relative;
  width: 100%;
  height: 3.85rem;
  box-sizing: border-box;
  transition: none;
  cursor: pointer;
  overflow: hidden;
  transition: height 0.2s ease-in-out;

  @media (max-width: 767px) {
    &.open {
      height: 0;
    }
  }

  h3 {
    display: block;
    position: absolute;
    top: 1.063rem;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    white-space: nowrap;
  }

  .holiday,
  .new {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .holiday {
    display: none;
    background-image: url(./../../assets/mixology/cans/holiday-snow.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom;
  }

  .new {
    background-image: url(./../../assets/mixology/cans/featured-new-m.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center right;
  }

  img {
    position: absolute;
    left: 0;
    bottom: 0;

    &.desktop {
      display: none;
      z-index: 3;

      @media (min-width: 768px) {
        display: block;
        // transition: all 0.3s, height 0.3s;
      }
    }

    &.mobile {
      right: 0;
      margin: auto 0;
      height: 100%;
      width: auto;
      min-width: 500px;
      z-index: 1;

      @media (min-width: 768px) {
        display: none;
      }
    }
  }

  .btn-arrow {
    display: block;
    position: absolute;
    width: 18px;
    height: 18px;
    right: 5px;
    bottom: 0;
    top: 0;
    margin: auto 0;
    fill: #fff;
  }

  @media (min-width: 768px) {
    position: relative;
    display: block;
    width: unset;
    height: calc(25vw - 5px);
    border: 1px solid #fff;
    transition: none;
    white-space: normal;

    &:hover .btn-arrow {
      -webkit-transform: rotate(450deg);
      transform: rotate(450deg);
    }

    img {
      &.desktop {
        display: block;
      }

      &.mobile {
        display: none;
      }
    }

    .btn-arrow {
      bottom: 5px;
      left: 5px;
      top: unset;
      margin: unset;
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg);
      -webkit-transition: -webkit-transform 0.3s ease-in-out;
      transition: transform 0.3s ease-in-out;
    }

    @media (min-width: 769px) {
      transition: margin 0.3s, height 0.3s;
      transition-timing-function: ease-out;
      /* transition-delay: 0.1s; */
      .holiday {
        display: block;
      }
      .new {
        background-image: url(./../../assets/mixology/cans/featured-new.png);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: bottom;
      }
    }

    @media (min-width: 1200px) {
      /* width: 16.66vw; */
      height: calc(16.66vw - 3px);
    }

    @media (min-width: 1600px) {
      /* width: 12.5vw; */
      height: calc(12.5vw - 2px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mixology/Tile.vue